export const sanitizeQueryParams = (params) =>
  Object.entries(params).reduce((acc, [key, value]) => {
    if (value === null || value === undefined) {
      return acc
    }

    if (typeof value === 'string') {
      const trimmed = value.trim()
      if (trimmed.length === 0) {
        return acc
      }
      acc[key] = trimmed
      return acc
    }

    if (value instanceof Date) {
      acc[key] = value.toISOString()
      return acc
    }

    acc[key] = value
    return acc
  }, {})

export const buildFallbackSummary = (exception, data) => {
  const type = (exception || '').toLowerCase()

  if (type === 'overfill') {
    const litres = Number(data?.litres)
    const tank = Number(data?.tankSize)
    if (Number.isFinite(litres) && Number.isFinite(tank)) {
      return `${Math.round(litres)}l of fuel was purchased for a vehicle that has a ${Math.round(
        tank
      )}l tank capacity.`
    }
    return 'Fuel purchased exceeded the recorded tank capacity.'
  }

  if (type === 'wrong fuel type') {
    const purchased = data?.productPurchased || data?.product || 'Fuel'
    const expected = data?.milesFuelType || 'an unknown'
    return `${purchased} was purchased for the vehicle that has ${expected} fuel type.`
  }

  if (type === 'multi fill') {
    return 'Multiple fuel purchases were recorded for this vehicle.'
  }

  if (type === 'odometer') {
    return 'An odometer discrepancy was recorded for this transaction.'
  }

  return 'Exception details are unavailable.'
}

export const normalizeExceptionValue = (value) =>
  typeof value === 'string' ? value.replace(/[-\s]/g, '').toLowerCase() : ''
